<template>
    <div class="content mx-0 text-center flex items-center justify-between flex-col pb-8">
        <h2 class="theme-ui-text-color theme-question-shadow text-white my-0 text-title pt-12 sm:pt-16">
            {{ $t('countdown_header') }}
        </h2>
        <h3 id="number-counting" class="theme-ui-text-color theme-question-shadow text-white text-timing"></h3>
        <button
            id="go-btn"
            class="theme-button btn btn-large uppercase font-opensans font-size-22"
            @click="handleClickNext"
        >
            {{ $t('countdown_button_go') }}
        </button>
    </div>
</template>

<script>
import helperMixins from '@/mixins/helper.js'
export default {
    name: 'countdown',

    data() {
        return {
            timing: 3,
            interval: null,
            isClickGo: false
        }
    },

    mixins: [helperMixins],

    mounted: function () {
        this.touchActionNone()

        let numberEle = document.getElementById('number-counting')
        numberEle.innerText = this.timing
        this.interval = setInterval(() => {
            this.timing--
            numberEle.innerText = this.timing

            if (this.timing <= 1) {
                clearInterval(this.interval)
                setTimeout(() => {
                    this.handleClickNext()
                }, 500)
            }
        }, 1000)
    },

    methods: {
        handleClickNext: function () {
            document.querySelector('#go-btn').style.pointerEvents = 'none'

            if (this.isClickGo) {
                return
            }

            this.isClickGo = true

            clearInterval(this.interval)
            this.$emit('handleClickNext')
        }
    }
}
</script>


<style lang="scss" scoped>
.text-title {
    font-size: 3rem;

    @media (max-width: 767px) {
        font-size: 2rem;
    }

    @media (max-width: 320px) {
        padding-top: 1rem;
    }
}
.content {
    @media (max-width: 767px) {
        height: 80vh;
    }
}
.text-timing {
    font-size: calc(8vw + 8vh);
    line-height: 0;

    animation-name: counting;
    animation-duration: 1s;
    animation-delay: 0.5s;
    animation-fill-mode: both;
    animation-iteration-count: infinite;

    @media (max-width: 767px) {
        font-size: 8rem;
    }

    @keyframes counting {
        0% {
            transform: scale(1);
            opacity: 1;
        }
        50% {
            transform: scale(0.5);
            opacity: 0;
        }
        100% {
            transform: scale(1);
            opacity: 1;
        }
    }
}
</style>